
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GuestErrorPage from '../Guest/ErrorPage/ErrorPage';
import MemberErrorPage from '../Member/ErrorPage/ErrorPage';
import { connect } from 'react-redux';
import _ from 'lodash';

export class ErrorPage extends Component {
    static propTypes = {
        isMemberFlow: PropTypes.bool,
        errorType: PropTypes.string
    };
    render() {
        const { isMemberFlow } = this.props;
        return (
            isMemberFlow ? <MemberErrorPage /> : <GuestErrorPage />
        );
    }
}

export const mapStateToProps = state => ({
    isMemberFlow: _.get(state, 'serverData.isMemberFlow', false),
});

export default connect(mapStateToProps, null)(ErrorPage);
